import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import NyliaButton from "../nyliaButton/NyliaButton.js";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";
import ListGroup from "react-bootstrap/ListGroup";

import img1 from "../../assets/enrollPage/ThreeAdultDancers-2000.JPG";
import preBallet1Sm from "../../assets/classesPage/evanButterfly300.JPG";
import preBallet1Md from "../../assets/classesPage/evanButterfly768.JPG";
import preBallet1Lg from "../../assets/classesPage/evanButterfly1280.JPG";
import preBallet1XL from "../../assets/classesPage/evanButterfly2000.JPG";
import preBallet2Sm from "../../assets/classesPage/preballetII-300.JPG";
import preBallet2Md from "../../assets/classesPage/preballetII-768.JPG";
import preBallet2Lg from "../../assets/classesPage/preballetII-1280.JPG";
import preBallet2XL from "../../assets/classesPage/preballetII-2000.JPG";
import ballet1Sm from "../../assets/classesPage/balletI-300.jpg";
import ballet1Md from "../../assets/classesPage/balletI-768.jpg";
import ballet1Lg from "../../assets/classesPage/balletI-1280.jpg";
import ballet1XL from "../../assets/classesPage/balletI-2000.jpg";
import ballet2Sm from "../../assets/classesPage/balletII-300.jpeg";
import ballet2Md from "../../assets/classesPage/balletII-768.jpeg";
import ballet2Lg from "../../assets/classesPage/balletII-1280.jpeg";
import ballet2XL from "../../assets/classesPage/balletII-2000.jpeg";
import ballet4Sm from "../../assets/classesPage/balletIV-300.JPG";
import ballet4Md from "../../assets/classesPage/balletIV-768.JPG";
import ballet4Lg from "../../assets/classesPage/balletIV-1280.JPG";
import ballet4XL from "../../assets/classesPage/balletIV-2000.JPG";
import ballet5Sm from "../../assets/classesPage/balletV-300.JPG";
import ballet5Md from "../../assets/classesPage/balletV-768.JPG";
import ballet5Lg from "../../assets/classesPage/balletV-1280.JPG";
import ballet5XL from "../../assets/classesPage/balletV-2000.JPG";

// Ballet III
import ballet3Sm from "../../assets/classesPage/300/BalletIII.png";
import ballet3Md from "../../assets/classesPage/768/BalletIII.png";
import ballet3Lg from "../../assets/classesPage/1280/BalletIII.png";
import ballet3XL from "../../assets/classesPage/2000/BalletIII.png";

// Ballet VI & VII
import ballet6Sm from "../../assets/classesPage/300/BalletVI.png";
import ballet6Md from "../../assets/classesPage/768/BalletVI.png";
import ballet6Lg from "../../assets/classesPage/1280/BalletVI.png";
import ballet6XL from "../../assets/classesPage/2000/BalletVI.png";
import ballet7Sm from "../../assets/classesPage/300/BalletVII.png";
import ballet7Md from "../../assets/classesPage/768/BalletVII.png";
import ballet7Lg from "../../assets/classesPage/1280/BalletVII.png";
import ballet7XL from "../../assets/classesPage/2000/BalletVII.png";

// Pointe
import pointeISm from "../../assets/classesPage/300/PointeI.png";
import pointeIMd from "../../assets/classesPage/768/PointeI.png";
import pointeILg from "../../assets/classesPage/1280/PointeI.png";
import pointeIXL from "../../assets/classesPage/2000/PointeI.png";
import pointeIISm from "../../assets/classesPage/300/PointeII.png";
import pointeIIMd from "../../assets/classesPage/768/PointeII.png";
import pointeIILg from "../../assets/classesPage/1280/PointeII.png";
import pointeIIXL from "../../assets/classesPage/2000/PointeII.png";

// Adult/Teen Ballet
import allLevelsAdultBalletSm from "../../assets/classesPage/300/All-Levels.png";
import allLevelsAdultBalletMd from "../../assets/classesPage/768/All-Levels.png";
import allLevelsAdultBalletLg from "../../assets/classesPage/1280/All-Levels.png";
import allLevelsAdultBalletXL from "../../assets/classesPage/2000/All-Levels.png";
import begAdultBalletSm from "../../assets/classesPage/300/TeenAndAdult-Beginner.png";
import begAdultBalletMd from "../../assets/classesPage/768/TeenAndAdult-Beginner.png";
import begAdultBalletLg from "../../assets/classesPage/1280/TeenAndAdult-Beginner.png";
import begAdultBalletXL from "../../assets/classesPage/2000/TeenAndAdult-Beginner.png";
import intAdvAdultBalletSm from "../../assets/classesPage/300/TeenAndAdult-IntAdv.png";
import intAdvAdultBalletMd from "../../assets/classesPage/768/TeenAndAdult-IntAdv.png";
import intAdvAdultBalletLg from "../../assets/classesPage/1280/TeenAndAdult-IntAdv.png";
import intAdvAdultBalletXL from "../../assets/classesPage/2000/TeenAndAdult-IntAdv.png";

import adultBalletSm from "../../assets/classesPage/advAdultBallet-300.jpg";
import adultBalletMd from "../../assets/classesPage/advAdultBallet-768.jpg";
import adultBalletLg from "../../assets/classesPage/advAdultBallet-1280.jpg";
import adultBalletXL from "../../assets/classesPage/advAdultBallet-2000.jpg";

// NBYC
import nbcNoviceSm from "../../assets/classesPage/300/NBYC-Novice.png";
import nbcNoviceMd from "../../assets/classesPage/768/NBYC-Novice.png";
import nbcNoviceLg from "../../assets/classesPage/1280/NBYC-Novice.png";
import nbcNoviceXL from "../../assets/classesPage/2000/NBYC-Novice.png";
import nbcJrPreProfSm from "../../assets/classesPage/300/NBYC-JrPreProfessional.png";
import nbcJrPreProfMd from "../../assets/classesPage/768/NBYC-JrPreProfessional.png";
import nbcJrPreProfLg from "../../assets/classesPage/1280/NBYC-JrPreProfessional.png";
import nbcJrPreProfXL from "../../assets/classesPage/2000/NBYC-JrPreProfessional.png";

// NBC
import nbcApprenticeSm from "../../assets/classesPage/300/NBC-Apprentice.png";
import nbcApprenticeMd from "../../assets/classesPage/768/NBC-Apprentice.png";
import nbcApprenticeLg from "../../assets/classesPage/1280/NBC-Apprentice.png";
import nbcApprenticeXL from "../../assets/classesPage/2000/NBC-Apprentice.png";
import nbcCorpsAndSoloistsSm from "../../assets/classesPage/300/NBC-Corps.png";
import nbcCorpsAndSoloistsMd from "../../assets/classesPage/768/NBC-Corps.png";
import nbcCorpsAndSoloistsLg from "../../assets/classesPage/1280/NBC-Corps.png";
import nbcCorpsAndSoloistsXL from "../../assets/classesPage/2000/NBC-Corps.png";

// Misc. Classes
import contMusicalTheatreSm from "../../assets/classesPage/300/ContemporaryMusicalTheatre.png";
import contMusicalTheatreMd from "../../assets/classesPage/768/ContemporaryMusicalTheatre.png";
import contMusicalTheatreLg from "../../assets/classesPage/1280/ContemporaryMusicalTheatre.png";
import contMusicalTheatreXL from "../../assets/classesPage/2000/ContemporaryMusicalTheatre.png";
import flexibilitySm from "../../assets/classesPage/300/Flexibility.png";
import flexibilityMd from "../../assets/classesPage/768/Flexibility.png";
import flexibilityLg from "../../assets/classesPage/1280/Flexibility.png";
import flexibilityXL from "../../assets/classesPage/2000/Flexibility.png";
import flexibilityTeenAdultSm from "../../assets/classesPage/300/Flexibility-Teen.png";
import flexibilityTeenAdultMd from "../../assets/classesPage/768/Flexibility-Teen.png";
import flexibilityTeenAdultLg from "../../assets/classesPage/1280/Flexibility-Teen.png";
import flexibilityTeenAdultXL from "../../assets/classesPage/2000/Flexibility-Teen.png";
import improvAndMovementSm from "../../assets/classesPage/300/ImprovAndMovement.png";
import improvAndMovementMd from "../../assets/classesPage/768/ImprovAndMovement.png";
import improvAndMovementLg from "../../assets/classesPage/1280/ImprovAndMovement.png";
import improvAndMovementXL from "../../assets/classesPage/2000/ImprovAndMovement.png";
import strengthSm from "../../assets/classesPage/300/Strength.png";
import strengthMd from "../../assets/classesPage/768/Strength.png";
import strengthLg from "../../assets/classesPage/1280/Strength.png";
import strengthXL from "../../assets/classesPage/2000/Strength.png";

import "./ClassPopup.css";

// Array. Order is important!
const imagesList = [
  {
    id: 0,
    src: preBallet1Sm,
    imgSet: `${preBallet1Sm} 300w, ${preBallet1Md} 768w, ${preBallet1Lg} 1280w, ${preBallet1XL} 2000w`,
    alt: "Nylia Ballet Academy's Pre-Ballet I classical ballet technique class",
  },
  {
    id: 1,
    src: preBallet2Sm,
    imgSet: `${preBallet2Sm} 300w, ${preBallet2Md} 768w, ${preBallet2Lg} 1280w, ${preBallet2XL} 2000w`,
    alt:
      "Nylia Ballet Academy's Pre-Ballet II classical ballet technique class",
  },
  {
    id: 2,
    src: ballet1Sm,
    imgSet: `${ballet1Sm} 300w, ${ballet1Md} 768w, ${ballet1Lg} 1280w, ${ballet1XL} 2000w`,
    alt: "Nylia Ballet Academy's Ballet I classical ballet technique class",
  },
  {
    id: 3,
    imgSet: `${ballet2Sm} 300w, ${ballet2Md} 768w, ${ballet2Lg} 1280w, ${ballet2XL} 2000w`,
    alt: "Nylia Ballet Academy's Ballet II classical ballet technique class",
  },
  {
    id: 4,
    imgSet: `${ballet3Sm} 300w, ${ballet3Md} 768w, ${ballet3Lg} 1280w, ${ballet3XL} 2000w`,
    alt: "Nylia Ballet Academy's Ballet III classical ballet technique class",
  },
  {
    id: 5,
    imgSet: `${ballet4Sm} 300w, ${ballet4Md} 768w, ${ballet4Lg} 1280w, ${ballet4XL} 2000w`,
    alt: "Nylia Ballet Academy's Ballet IV classical ballet technique class",
  },
  {
    id: 6,
    imgSet: `${ballet5Sm} 300w, ${ballet5Md} 768w, ${ballet5Lg} 1280w, ${ballet5XL} 2000w`,
    alt: "Nylia Ballet Academy's Ballet V classical ballet technique class",
  },
  {
    id: 7,
    imgSet: `${ballet6Sm} 300w, ${ballet6Md} 768w, ${ballet6Lg} 1280w, ${ballet6XL} 2000w`,
    alt: "Nylia Ballet Academy's Ballet VI classical ballet technique class",
  },
  {
    id: 8,
    imgSet: `${ballet7Sm} 300w, ${ballet7Md} 768w, ${ballet7Lg} 1280w, ${ballet7XL} 2000w`,
    alt: "Nylia Ballet Academy's Ballet VII classical ballet technique class",
  },
  {
    id: 9,
    imgSet: `${pointeISm} 300w, ${pointeIMd} 768w, ${pointeILg} 1280w, ${pointeIXL} 2000w`,
    alt: "Nylia Ballet Academy's Pointe I classical ballet technique class",
  },
  {
    id: 10,
    imgSet: `${pointeIISm} 300w, ${pointeIIMd} 768w, ${pointeIILg} 1280w, ${pointeIIXL} 2000w`,
    alt: "Nylia Ballet Academy's Pointe II classical ballet technique class",
  },
  {
    id: 11,
    imgSet: `${begAdultBalletSm} 300w, ${begAdultBalletMd} 768w, ${begAdultBalletLg} 1280w, ${begAdultBalletXL} 2000w`,
    alt:
      "Nylia Ballet Academy's Beginner Adult and Teen classical ballet technique class",
  },
  {
    id: 12,
    imgSet: `${intAdvAdultBalletSm} 300w, ${intAdvAdultBalletMd} 768w, ${intAdvAdultBalletLg} 1280w, ${intAdvAdultBalletXL} 2000w`,
    alt:
      "Nylia Ballet Academy's Intermediate and Advanced Adult and Teen classical ballet technique class",
  },
  {
    id: 13,
    imgSet: `${allLevelsAdultBalletSm} 300w, ${allLevelsAdultBalletMd} 768w, ${allLevelsAdultBalletLg} 1280w, ${allLevelsAdultBalletXL} 2000w`,
    alt:
      "Nylia Ballet Academy's All-Levels Adult and Teen classical ballet technique class",
  },
  {
    id: 14,
    imgSet: `${flexibilitySm} 300w, ${flexibilityMd} 768w, ${flexibilityLg} 1280w, ${flexibilityXL} 2000w`,
    alt: "Nylia Ballet Academy's Flexibility  class",
  },
  {
    id: 15,
    imgSet: `${pointeIISm} 300w, ${pointeIIMd} 768w, ${pointeIILg} 1280w, ${pointeIIXL} 2000w`,
    alt: "Nylia Ballet Academy's Pointe II classical ballet technique class",
  },
  {
    id: 16,
    imgSet: `${strengthSm} 300w, ${strengthMd} 768w, ${strengthLg} 1280w, ${strengthXL} 2000w`,
    alt: "Nylia Ballet Academy's Strength class",
  },
  {
    id: 17,
    imgSet: `${nbcNoviceSm} 300w, ${nbcNoviceMd} 768w, ${nbcNoviceLg} 1280w, ${nbcNoviceXL} 2000w`,
    alt: "Nylia Ballet Academy's Pointe II classical ballet technique class",
  },
  {
    id: 18,
    imgSet: `${nbcJrPreProfSm} 300w, ${nbcJrPreProfMd} 768w, ${nbcJrPreProfLg} 1280w, ${nbcJrPreProfXL} 2000w`,
    alt: "Nylia Ballet Academy's Pointe II classical ballet technique class",
  },
  {
    id: 19,
    imgSet: `${nbcApprenticeSm} 300w, ${nbcApprenticeMd} 768w, ${nbcApprenticeLg} 1280w, ${nbcApprenticeXL} 2000w`,
    alt: "Nylia Ballet Academy's Nylia Ballet Company Apprentice class",
  },
  {
    id: 20,
    imgSet: `${nbcCorpsAndSoloistsSm} 300w, ${nbcCorpsAndSoloistsMd} 768w, ${nbcCorpsAndSoloistsLg} 1280w, ${nbcCorpsAndSoloistsXL} 2000w`,
    alt:
      "Nylia Ballet Academy's Nylia Ballet Company Corps de Ballet and Soloists class",
  },
  {
    id: 21,
    imgSet: `${contMusicalTheatreSm} 300w, ${contMusicalTheatreMd} 768w, ${contMusicalTheatreLg} 1280w, ${contMusicalTheatreXL} 2000w`,
    alt: "Nylia Ballet Academy's Contemporary Musical Theatre class",
  },
  {
    id: 22,
    imgSet: `${improvAndMovementSm} 300w, ${improvAndMovementMd} 768w, ${improvAndMovementLg} 1280w, ${improvAndMovementXL} 2000w`,
    alt: "Nylia Ballet Academy's Improvisation and Movement Exploration class",
  },
  {
    id: 23,
    imgSet: `${flexibilityTeenAdultSm} 300w, ${flexibilityTeenAdultMd} 768w, ${flexibilityTeenAdultLg} 1280w, ${flexibilityTeenAdultXL} 2000w`,
    alt: "Nylia Ballet Academy's Improvisation and Movement Exploration class",
  },
];

function ClassPopup({
  className,
  description,
  requirements,
  imgId,
  registrationReq,
  classTimes,
  dropInOrRegs,
  curDayOfWeekStr,
}) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div>
      <div id="classPopupCard">
        {/* Here goes the small list card */}
        <Card
          className="mb-3"
          style={{ maxWidth: "540px" }}
          onClick={handleShow}
        >
          <Row className="g-0">
            <Col md={4}>
              <Card.Img
                alt={imagesList[imgId].alt}
                src={imagesList[imgId].src}
                srcSet={imagesList[imgId].imgSet}
              />
            </Col>
            <Col md={8}>
              <Card.Body>
                <Card.Title>
                  <b>{className}</b>
                </Card.Title>
                <Card.Text></Card.Text>
                <Card.Text>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-calendar-event"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z" />
                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                  </svg>{" "}
                  {curDayOfWeekStr}
                  <br></br>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-clock"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                  </svg>{" "}
                  {
                    classTimes.filter((classTimesInfo) =>
                      curDayOfWeekStr.includes(classTimesInfo.weekDay)
                    )[0].startTime
                  }
                  <br></br>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-person-circle"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                    <path
                      fill-rule="evenodd"
                      d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"
                    />
                  </svg>{" "}
                  {
                    classTimes.filter((classTimesInfo) =>
                      curDayOfWeekStr.includes(classTimesInfo.weekDay)
                    )[0].instructor
                  }
                </Card.Text>
              </Card.Body>
            </Col>
          </Row>{" "}
          <Card.Footer>
            <i>Full Class Details</i>
          </Card.Footer>{" "}
        </Card>
      </div>

      <div className="">
        <Modal id="classPopup" show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{className}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <img
              alt={imagesList[imgId].alt}
              src={imagesList[imgId].src}
              srcSet={imagesList[imgId].imgSet}
            />{" "}
            <br /> <br />
            <p>{description}</p>
            <ListGroup as="ol" numbered>
              {classTimes.map((item, idx) => (
                <div>
                  <ListGroup.Item
                    as="li"
                    className="d-flex justify-content-between align-items-start"
                  >
                    <div className="ms-2 me-auto">
                      <div className="fw-bold">{item.weekDay}</div>
                      {item.startTime + " - " + item.endTime}
                    </div>
                    <Badge bg="primary" pill>
                      {item.instructor}
                    </Badge>
                  </ListGroup.Item>
                </div>
              ))}
            </ListGroup>{" "}
            <br />
            <h2>
              <b>REQUIREMENTS</b>
            </h2>
            <p>
              <ul>
                {requirements.map((item) => (
                  <li>{item}</li>
                ))}
                {/* <li>{requirements}</li> */}
                <li>{dropInOrRegs}</li>
              </ul>
            </p>
          </Modal.Body>
          <Modal.Footer id="eventPopupFooter">{className}</Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

export default ClassPopup;
